import React from 'react';
import PropTypes from 'prop-types';
import { Button, SvgIcon, Tooltip } from '@mui/material';
import { RadioButtonUnchecked as RadioButtonUncheckedIcon } from '@mui/icons-material';
import { Info as InfoIcon } from '@mui/icons-material';
import CheckCircleIcon from '../../../../../icons/check-circle.svg?react';
import './ButtonInputWithoutIcon.scss';

export default function ButtonInput(props) {

    return (
        <Button
            variant={props.value ? 'outlined' : 'contained'}
            className={`shadow aflac-button-card-input ${props.value ? `'active mt-4 button-active-border` : 'inactive mt-4'} ${props.mobileWide ? 'wide-sm' : ''}`}
            onClick={props.onClick}
            aria-pressed={props.value}
            aria-labelledby={props.title}
        >
            <span className='aflac-btn-span'>
                {props.infoText && (
                    <Tooltip title={props.infoText} className="float-end m-0">
                        <InfoIcon color="action"></InfoIcon>
                    </Tooltip>
                )}
                <h1 className="title">{props.title}</h1>
                {props.subtitle && <p className="subtitle">{props.subtitle}</p>}
                {props.value ? (
                    <SvgIcon component={CheckCircleIcon} color="primary" name={props.productName} className="check" />
                ) : (
                    <SvgIcon component={RadioButtonUncheckedIcon} color="disabled" className="unCheck" />
                )}
            </span>
        </Button>
    );
}

ButtonInput.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    value: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    mobileWide: PropTypes.bool,
};
